import { render, staticRenderFns } from "./energy.vue?vue&type=template&id=bd16f2ea&scoped=true"
import script from "./energy.vue?vue&type=script&lang=js"
export * from "./energy.vue?vue&type=script&lang=js"
import style0 from "./energy.vue?vue&type=style&index=0&id=bd16f2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd16f2ea",
  null
  
)

export default component.exports